module.exports = __webpack_public_path__ + "img/1490699260.34652600.jpg";